import React, { useEffect, useContext, useState } from "react";
import Styles from "../styles/Reports.module.css";
import { postsAPI } from "../services/api";
import { UserContext } from "./context/user/UserContext";
import ConfirmModal from "./ConfirmModal";
import { useNavigate } from "react-router-dom";

const Reports = () => {
  const { userData } = useContext(UserContext);
  const token = userData?.token;
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const getposts = async () => {
    try {
      const data = await postsAPI.getReportedPosts();
      console.log(data);
      setPosts(data);
    } catch (error) {
      console.log("Some error occurred:", error);
    }
  };
  useEffect(() => {
    getposts();
  }, []);
  const [input, setInput] = useState(null);
  const [confirmModal, setConfirmModal] = useState({ isOpen: false, postId: null });

  const handleDeleteClick = (postId) => {
    setConfirmModal({ isOpen: true, postId });
  };

  const handleDeleteConfirm = async () => {
    const postId = confirmModal.postId;
    
    try {
      await postsAPI.deletePost(token, postId);
      
      // Only remove from list AFTER successful deletion
      setPosts(posts.filter(post => post.id !== postId));
      
      alert('Post deleted successfully! ✅');
    } catch (error) {
      console.log("Error in deleting:", error);
      alert(`Failed to delete post: ${error.message}`);
    }
  };

  return (
    <div className={Styles.container}>
      <div className={Styles.input}>
        <input
          type="text"
          className={Styles.input}
          onChange={(e) => setInput(e.target.value)}
        />
        <button
          className={Styles.delete_button}
          onClick={() => handleDeleteClick(input)}
        >
          Delete
        </button>
        <button
          className={Styles.back_button}
          onClick={() => navigate("/admin")}
        >
          {" "}
          Dashboard
        </button>
      </div>
      <div className={Styles.heading}>
        <h2>Reported Posts</h2>
      </div>
      <div className={Styles.posts_list}>
        <table>
          <thead>
            <tr>
              <th>Post ID</th>
              <th>Reasons</th>
              <th>User ID</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {posts?.map((post) => (
              <tr key={post.id}>
                <td>{post.id}</td>

                <td className="reason">
                  {post.report_reasons?.map((reason, index) => (
                    <span key={index} className="reason">
                      {reason} <br />
                    </span>
                  ))}
                </td>
                <td>{post.posted_by}</td>
                <td>
                  <button
                    className={Styles.delete_button}
                    onClick={() => handleDeleteClick(post.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ConfirmModal
        isOpen={confirmModal.isOpen}
        onClose={() => setConfirmModal({ isOpen: false, postId: null })}
        onConfirm={handleDeleteConfirm}
        title="Delete Reported Location?"
        message="Are you sure you want to delete this reported location? This action cannot be undone."
        confirmText="Yes, Delete"
        cancelText="Cancel"
        type="danger"
      />
    </div>
  );
};

export default Reports;
